import { useEffect, useState } from 'react'
import { useContractStore } from 'context/ContractStore'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import { UserIcon } from 'asterX-UI/Icons/UserIcon'
import { getValidDate } from 'lib/utils'
import { useStyles } from './comments.styles'

export const Comments = () => {
  const classes = useStyles()
  const {
    contractStore: { comments },
    contractStoreFunc
  } = useContractStore()
  const [comment, setComment] = useState()

  useEffect(() => {
    contractStoreFunc.getById()
  }, [])

  const handleAddComment = async () => {
    if (!comment) {
      return null
    }

    await contractStoreFunc.addComment(comment)
    setComment('')
  }

  return (
    <Grid container style={{ maxWidth: 680 }} spacing={10}>
      <Grid item container spacing={5}>
        {(comments || []).map(
          (item, i) =>
            item?.comment !== '' && (
              <Grid item container key={`comment-${i}`} spacing={4}>
                <Grid item container alignItems={'center'} xs={12} spacing={4}>
                  <Grid item className={classes.avatar}>
                    <UserIcon />
                  </Grid>
                  <Grid item container style={{ width: 'auto', flexGrow: 1 }}>
                    <Grid item container alignItems={'center'} spacing={2}>
                      <Grid item>
                        <Typography variant={'subtitle2'} style={{ fontSize: 14 }}>
                          {item?.userFullName}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant={'body2'} style={{ fontSize: 12 }}>
                          {getValidDate(item?.createdDate)}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant={'body2'}>{item?.role}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.comment} variant={'body1'}>
                    {item?.comment}
                  </Typography>
                </Grid>
              </Grid>
            )
        )}
      </Grid>
      <Grid item container justifyContent={'flex-end'} spacing={3}>
        <Grid item xs={12}>
          <TextField
            minRows={3}
            value={comment}
            onChange={e => setComment(e.target.value)}
            fullWidth
            multiline
            placeholder={'Напишите комментарий...'}
          />
        </Grid>
        <Grid item>
          <Button color="primary" variant={'contained'} onClick={handleAddComment}>
            Отправить
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
